import { Permissions } from 'lib/types/global';
import { camelCase } from 'lib/utils/objectSerializer';

import {
  API_LOGIN_SUCCESS,
  API_READ_SESSION_SUCCESS,
} from '../session/actionTypes';
import { SessionAction } from '../session/actions';

export type PermissionsState = Permissions;

export const initialState: PermissionsState = {};

export default function permissionsReducer(
  state: PermissionsState = initialState,
  action: SessionAction,
): PermissionsState {
  switch (action.type) {
    case API_LOGIN_SUCCESS:
    case API_READ_SESSION_SUCCESS:
      return { ...camelCase(action.payload.links) };

    default:
      return state;
  }
}
